import { render } from "./RcptCreate3Edit.vue?vue&type=template&id=7d688170"
import script from "./RcptCreate3Edit.vue?vue&type=script&lang=js"
export * from "./RcptCreate3Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__